var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.127 4.615c1.28-.264 2.253-.279 3.06-.179.945.119 1.704.4 2.552.718l.025.01c.834.312 1.756.658 2.91.802.932.117 1.988.1 3.27-.133v7.566c-1.28.263-2.253.278-3.06.178-.945-.118-1.704-.4-2.552-.718l-.026-.01c-.833-.312-1.755-.658-2.91-.802-.931-.117-1.987-.1-3.27.133V4.615Zm12.457-.648c-1.604.401-2.764.442-3.7.324-.945-.118-1.704-.4-2.552-.717l-.026-.01c-.833-.313-1.755-.659-2.91-.802-1.17-.147-2.537-.083-4.301.357a.844.844 0 0 0-.657.823v14.35a.844.844 0 1 0 1.689 0V13.9c1.28-.263 2.253-.279 3.06-.178.945.118 1.704.4 2.552.717l.025.01c.834.313 1.756.659 2.91.803 1.174.146 2.547.081 4.32-.362a.844.844 0 0 0 .639-.819V4.786a.844.844 0 0 0-1.049-.819Z",
    fill: "#515151"
  })));
};

export default SvgFlagIcon;